// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"Card_cardContainer__3WeJ3","img":"Card_img__XQqJa","title":"Card_title__199Fy"};